import { createConditionRule, createConditionRulesFormField, createFilterFieldPattern, createFilterFieldPatternFormField } from './_condition-rules';
import { createFieldTransformation, createFieldTransformationFormField } from './_transform';
import { createDataType, createDataTypeFormField } from './_type';
import { isDataType, isDataTypeFormField, isDataValue, isDataValueFormField } from './_utils';
import { createDataValue, createDataValueFormField } from './_value';
import { createFieldDataSource, createFieldDataSourceFormField } from './data-source/_data-source';

/** Field logic. */
const fieldLogic = {
  isDataType,
  isDataTypeFormField,
  createDataType,
  createDataTypeFormField,

  isDataValue,
  isDataValueFormField,
  createDataValue,
  createDataValueFormField,

  createFieldDataSource,
  createFieldDataSourceFormField,

  createConditionRule,
  createConditionRulesFormField,
  createFilterFieldPattern,
  createFilterFieldPatternFormField,

  createFieldTransformation,
  createFieldTransformationFormField,
};

export type { DataTypeFormField, DataTypeFormFieldGeneral, DataTypeFormFieldList, DataTypeFormFieldTable, DataTypeFormFieldTableColumn } from './_type.type';
export type {
  DataValueFormField,
  DataValueFormFieldGeneral,
  DataValueFormFieldList,
  DataValueFormFieldTable,
  DataValueFormFieldTableWithColumns,
} from './_value.type';
export type {
  FieldDataSourceFormField,
  FieldDataSourceFormFieldAI,
  FieldDataSourceFormFieldAuto,
  FieldDataSourceFormFieldManual,
} from './data-source/_data-source.type';

export default fieldLogic;
